export enum ProductType {
  MOTORCYCLES = 'motorcycles',
  ACCESSORIES = 'accessories',
  CLOTHING = 'clothing',
  SPAREPARTS = 'spareparts',
  VENDORSPAREPARTS = 'vendorspareparts',
}
